<script setup lang="ts">
import { UserCircleIcon, LogoutIcon } from '@heroicons/vue/solid';
const { logout, userData } = useAuth();
</script>

<template>
  <div class="hidden flex-row items-center gap-4 md:flex">
    <DropdownMenu>
      <DropdownMenuTrigger class="group transition-colors hover:text-gunmetal" aria-label="Account menu">
        <UserCircleIcon class="size-6" aria-hidden="true" />
        <OverlayBlur variant="sm" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Hello {{ userData?.humanName?.firstName }}</DropdownMenuLabel>
        <DropdownMenuItem @click="logout" aria-label="Log out of your account">
          <LogoutIcon class="size-4" aria-hidden="true" /> Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>
